function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["children", "component", "maxWidth", "minWidth", "uiTheme"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import styled from 'styled-components';
import PropTypes from 'prop-types';
import renderByCloning from '../../utils/renderByCloning';
import { getBreakpoint } from '../Theme/selectors';
import withTheme from '../Theme/withTheme';
var Hide = function Hide(_ref) {
  var children = _ref.children,
    component = _ref.component,
    maxWidth = _ref.maxWidth,
    minWidth = _ref.minWidth,
    uiTheme = _ref.uiTheme,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return renderByCloning(component, children, _objectSpread({}, otherProps));
};
Hide.propTypes = {
  children: PropTypes.any.isRequired,
  component: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  uiTheme: PropTypes.object
};
Hide.defaultProps = {
  component: null,
  maxWidth: null,
  minWidth: null,
  uiTheme: null
};
var StyledHide = styled(Hide)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  var maxWidthKey = props.maxWidth,
    minWidthKey = props.minWidth,
    uiTheme = props.uiTheme;
  var minWidth = getBreakpoint(uiTheme, minWidthKey);
  var maxWidth = getBreakpoint(uiTheme, maxWidthKey);
  if (minWidth && maxWidth) {
    return "@media screen and (min-width: ".concat(minWidth, "px) and (max-width: ").concat(maxWidth, "px) {\n        display: none;\n      }");
  }
  if (minWidth) {
    return "@media screen and (min-width: ".concat(minWidth, "px) {\n        display: none;\n      }");
  }
  if (maxWidth) {
    return "@media screen and (max-width: ".concat(maxWidth, "px) {\n        display: none;\n      }");
  }
  return '';
});
export default withTheme(StyledHide);